import { render, staticRenderFns } from "./DiscountPrice.vue?vue&type=template&id=3c770f32&scoped=true&"
import script from "./DiscountPrice.vue?vue&type=script&lang=js&"
export * from "./DiscountPrice.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPrice.vue?vue&type=style&index=0&id=3c770f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c770f32",
  null
  
)

export default component.exports